import React from "react";
import { useField } from "formik";
import { FieldFeedbackLabel } from "./FieldFeedbackLabel";

const getFieldCSSClasses = (currentClass, touched, errors) => {
  const classes = currentClass
    ? [currentClass]
    : ["form-control", "form-control-solid"];
  if (touched && errors) {
    classes.push("is-invalid");
  }

  if (touched && !errors) {
    classes.push("is-valid");
  }

  return classes.join(" ");
};

export function Select({
  label,
  withFeedbackLabel = false,
  type = "text",
  customFeedbackLabel,
  children,
  required,
  inputClass,
  ...props
}) {
  const [field, meta] = useField(props);
  const { touched, error } = meta;
  return (
    <>
      {label && (
        <label>
          {label}
          {required && <span style={{ color: "red" }}> *</span>}
        </label>
      )}
      <select
        className={getFieldCSSClasses(inputClass, touched, error)}
        {...field}
        {...props}
      >
        {children}
      </select>
      {withFeedbackLabel && touched && (
        <FieldFeedbackLabel
          error={error}
          touched={touched}
          label={label}
          customFeedbackLabel={customFeedbackLabel}
        />
      )}
    </>
  );
}
